import { render, staticRenderFns } from "./MasterMenuPage.vue?vue&type=template&id=799e0bac&"
import script from "./MasterMenuPage.vue?vue&type=script&lang=js&"
export * from "./MasterMenuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports